export const COOKIE_MAX_AGE = 60 * 60 * 24 * 30 // 30 days
export const COOKIE_MAX_AGE_DAYS = COOKIE_MAX_AGE / (60 * 60 * 24)


export const EnumErrorCode = {
    PLEASE_VERIFY_YOUR_ACCOUNT: 'Please verify your account',
}